import React from 'react';
import {connect} from 'react-redux';
import Grid from "@material-ui/core/Grid";
import {Button} from "@blueprintjs/core";
import {stagingSetItemSelection, stagingSetItemStorageBay, stagingUpdateItems} from "../../Actions/StagingActions";

import DataLoader from "../../Lib/Api/DataLoader";

class StagingStorageBays extends React.Component {

  handleStorageSelection = (bay) => () => {
    const selectedItem = this.props.selectedItem;
    this.props.dispatch(stagingSetItemStorageBay(bay));
    DataLoader.submitData('staging/store', {
      onSuccess: this.handleStorageSuccess,
      data: {
        item: selectedItem.id,
        storage: this.props.storageFilter,
        storageBay: bay,
        storageNotes: '',
        location: this.props.location,
        installation: this.props.installationId,
      },
    });
  };

  handleShippingSelection = () => {
    const selectedItem = this.props.selectedItem;
    this.props.dispatch(stagingSetItemStorageBay("shipping"));
    DataLoader.submitData('staging/store', {
      onSuccess: this.handleStorageSuccess,
      data: {
        item: selectedItem.id,
        storage: null,
        storageBay: null,
        storageNotes: '',
        location: null,
        installation: this.props.installationId,
      },
    });
  };

  handleDeliveredSelection = () => {
    const selectedItem = this.props.selectedItem;
    this.props.dispatch(stagingSetItemStorageBay("delivered"));
    DataLoader.submitData('staging/store', {
      onSuccess: this.handleStorageSuccess,
      data: {
        item: selectedItem.id,
        storage: null,
        storageBay: null,
        storageNotes: '',
        location: this.props.location,
        installation: this.props.installationId,
      },
    });
  };

  handleMissingSelection = () => {
    const selectedItem = this.props.selectedItem;
    this.props.dispatch(stagingSetItemStorageBay("missing"));
    DataLoader.submitData('staging/store', {
      onSuccess: this.handleStorageSuccess,
      data: {
        item: selectedItem.id,
        storage: null,
        storageBay: 'INVALID',
        storageNotes: '',
        location: null,
        installation: this.props.installationId,
      },
    });
  };

  handleStorageSuccess = (payload) => {
    this.props.dispatch(stagingUpdateItems(payload));
  };

  cancelSelection = () => {
    this.props.dispatch(stagingSetItemSelection(null));
  };

  render() {
    const {selectedItem, storageFilter, storageBays, location, executingStorage} = this.props;
    if ( !selectedItem || !location || !storageBays[location] || !storageBays[location][storageFilter] ) return null;

    const filteredBays = storageBays[location][storageFilter];
    console.log(selectedItem);
    console.log("Staging Storage Bays");

    let bayButtons = [];
    filteredBays.forEach((bay) => {
      let className = "DeliveryStorageBay";
      if ( selectedItem.storage === bay ) className += " active";
      if ( filteredBays.length === 1 ) className += " single";
      bayButtons.push(
        <div key={bay} className={className}>
          <Button
            text={bay}
            className={"DeliveryStorageBay-Content"}
            intent={bay === executingStorage || selectedItem.storageBay === bay ? 'success' : null}
            disabled={!!executingStorage}
            onClick={this.handleStorageSelection(bay)}
            loading={bay === executingStorage}
          />
        </div>
      );
    });

    return (
      <>
        <div className={"DeliveryStorageBays"}>
          {bayButtons}
        </div>
        <div className={"DeliveryStorageSelection-Actions"}>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <Button
                fill
                icon={"geolocation"}
                text={"Shipping"}
                disabled={!!executingStorage}
                onClick={this.handleShippingSelection}
                loading={executingStorage === 'shipping'}
                intent={'shipping' === executingStorage || (!executingStorage && !selectedItem.location ) ? 'success' : null}
              />
            </Grid>
            <Grid item xs={4}>
              <Button
                fill
                icon={"box"}
                text={"Delivered"}
                disabled={!!executingStorage}
                onClick={this.handleDeliveredSelection}
                loading={executingStorage === 'delivered'}
                intent={'delivered' === executingStorage || (!executingStorage && selectedItem.location && !selectedItem.storageBay ) ? 'success' : null}
              />
            </Grid>
            <Grid item xs={4}>
              <Button
                fill
                intent={"danger"}
                icon={"disable"}
                text={"Not Received"}
                disabled={!!executingStorage}
                onClick={this.handleMissingSelection}
                loading={executingStorage === 'missing'}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                fill
                text={"Cancel"}
                disabled={!!executingStorage}
                onClick={this.cancelSelection}
                loading={executingStorage === 'missing'}
              />
            </Grid>
          </Grid>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const selectedInstallation = state.StagingReducer.selectedInstallation;
  return {
    storageFilter: state.StagingReducer.storageFilter,
    storageBays: state.StagingReducer.storageBays,
    selectedItem: state.StagingReducer.selectedItem,
    location: state.StagingReducer.installations[selectedInstallation].location,
    executingStorage: state.StagingReducer.executingStorage,
    installationId: state.StagingReducer.installations[selectedInstallation].id,
  };
}

export default connect(mapStateToProps)(StagingStorageBays);